import css from 'styled-jsx/css';
import { colors } from 'components/styles/variables';
import 'rc-slider/assets/index.css';

export const styles = css`
  .slider-container {
    height: 22px;
    display: flex;
    align-items: center;
  }
  .slider-container :global(.rc-slider-rail) {
    background-color: ${colors.G2};
    height: 2px;
    width: calc(100% + 22px);
    right: -11px;
  }

  .slider-container :global(.rc-slider-track) {
    background-color: ${colors.ALR1};
    height: 2px;
  }

  .slider-container :global(.rc-slider-handle) {
    width: 22px;
    height: 22px;
    border-radius: 4px;
    background-color: ${colors.WHITE};
    border: 1px solid #333;
    margin-top: -11px;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  }

  .slider-container.disable-min-change :global(.rc-slider-handle-1) {
    display: none;
  }

  .slider-container.disable-min-change :global(.rc-slider-track-1) {
    left: -10px !important;
  }

  .slider-container :global(.rc-slider-handle:hover) {
    height: 26px;
    width: 26px;
    margin-top: -12px;
  }

  .slider-container :global(.rc-slider-handle:active),
  .slider-container :global(.rc-slider-handle-dragging) {
    box-shadow: none;
  }
`;
